import apiBase from "../../api/axios";

export const getFrasesSeleccionAplicacionService = async (
  page = 1,
  search = "",
) => {
  let url = `v1/talentos-global/frases-seleccion-aplicacion/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const getFrasesSeleccionAplicacionSelectoresService = async (
  search = "",
) => {
  let url = `v1/talentos-global/selectores/frases-seleccion-aplicacion/`;
  if (search) {
    url += `?search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const getFraseSeleccionAplicacionByIdService = async (id) => {
  const response = await apiBase.get(
    `v1/talentos-global/frases-seleccion-aplicacion/${id}/`,
  );
  return response.data;
};

export const updateFraseSeleccionAplicacionService = async (id, payload) => {
  const response = await apiBase.put(
    `v1/talentos-global/frases-seleccion-aplicacion/${id}/`,
    payload,
  );
  return response.data;
};

export const toggleFraseSeleccionAplicacionActiveService = async (id) => {
  const response = await apiBase.post(
    `v1/talentos-global/frases-seleccion-aplicacion/${id}/toggle_active/`,
  );
  return response.data;
};
